import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import request from "../../utils/http";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { Checkbox } from "baseui/checkbox";

const UserCreate = () => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [hrTeam, setHrTeam] = useState(false);
	const [opsTeam, setOpsTeam] = useState(false);
	const [payrollTeam, setPayrollTeam] = useState(false);
	const [payrollPilTeam, setPayrollPilTeam] = useState(false);
	const [hrManager, setHrManager] = useState(false);
	const [systemAdmin, setSystemAdmin] = useState(false);

	const [userCreated, setUserCreated] = useState(false);
	const [id, setId] = useState("");
	const [password, setPassword] = useState("");

	const createUser = async () => {
		let result = await request("POST", "/api/admin/user/create", {
			name,
			email,
			hrTeam,
			opsTeam,
			payrollTeam,
			payrollPilTeam,
			hrManager,
			systemAdmin,
		});
		if (result.success && result.data) {
			const response = result.data;
			if (response.success) {
				setPassword(response.temporaryPassword);
				setId(response.id);
				setUserCreated(true);
			} else if (response.message) {
				toast("Unable to save: " + response.message, { type: "error" });
			} else {
				toast("Unable to save: " + JSON.stringify(response), {
					type: "error",
				});
			}
		}
	};

	const closePasswordModal = () => {
		navigate({
			pathname: `/user/${id}`,
		});
	};

	return (
		<>
			<h1>Create User</h1>
			<div>
				<FormControl label={"Name"}>
					<Input
						value={name}
						onChange={(e) => {
							setName(e.currentTarget.value);
						}}
					/>
				</FormControl>
				<FormControl label={"Email"}>
					<Input
						value={email}
						onChange={(e) => {
							setEmail(e.currentTarget.value);
						}}
					/>
				</FormControl>
				<FormControl label={"Is HR Team Member"}>
					<>
						<Checkbox
							key="hrTeam"
							checked={hrTeam}
							onChange={() => {
								setHrTeam(!hrTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is Operation Team Member"}>
					<>
						<Checkbox
							key="opsTeam"
							checked={opsTeam}
							onChange={() => {
								setOpsTeam(!opsTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is Payroll Team Member"}>
					<>
						<Checkbox
							key="payrollTeam"
							checked={payrollTeam}
							onChange={() => {
								setPayrollTeam(!payrollTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is PIL Create Team Member"}>
					<>
						<Checkbox
							key="payrollPilTeam"
							checked={payrollPilTeam}
							onChange={() => {
								setPayrollPilTeam(!payrollPilTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is HR Manager"}>
					<>
						<Checkbox
							key="hrManager"
							checked={hrManager}
							onChange={() => {
								setHrManager(!hrManager);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is System Administrator"}>
					<>
						<Checkbox
							key="systemAdmin"
							checked={systemAdmin}
							onChange={() => {
								setSystemAdmin(!systemAdmin);
							}}
						/>
					</>
				</FormControl>
				<div>
					<Button onClick={createUser}>Create</Button>
				</div>
			</div>
			<Modal onClose={closePasswordModal} isOpen={userCreated}>
				<ModalHeader>Temporary Password</ModalHeader>
				<ModalBody>
					A temporary password has been set. This will last for seven days. When
					you close this window, these details will be lost
					<br />
					<br />
					Username:{" "}
					<Input onChange={(event) => setEmail(email)} value={email} /> <br />
					Password:{" "}
					<Input
						onChange={(event) => setPassword(password)}
						type="password"
						value={password}
					/>{" "}
					<br />
				</ModalBody>
				<ModalFooter>
					<ModalButton onClick={closePasswordModal}>Done</ModalButton>
				</ModalFooter>
			</Modal>
		</>
	);
};
export default UserCreate;
